import { render } from "./EventDetails.vue?vue&type=template&id=2e9fb41d&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=ts"
export * from "./EventDetails.vue?vue&type=script&lang=ts"

import "./EventDetails.vue?vue&type=style&index=0&id=2e9fb41d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2e9fb41d"

export default script